const Gender = Object.freeze({
  FEMALE: 'female',
  MALE: 'male'
})

export default Gender
